import map1 from './map1.jpeg';
import map2 from './map2.jpeg';
import map3 from './map3.jpeg';
import map4 from './map4.jpeg';
import map5 from './map5.jpeg';
import map6 from './map6.jpeg';
import map7 from './map7.jpeg';
import map8 from './map8.jpeg';
import map9 from './map9.jpeg';
import map10 from './map10.jpeg';

const cityImges = [map1, map2, map3, map4, map5, map5, map6, map7, map8, map9, map10];

export default cityImges;
